/**
 * Can be used to store data on events for access across components
 * e.g. to provide early drag event data transfer access.
 */
import { defineStore } from "pinia";
import { computed, ref } from "vue";
export const useEventStore = defineStore("eventStore", () => {
    const dragData = ref(null);
    const multipleDragData = ref(false);
    const isMac = computed(() => navigator.userAgent.toUpperCase().indexOf("MAC") >= 0);
    function clearDragData() {
        dragData.value = null;
        multipleDragData.value = false;
    }
    function getDragData() {
        return dragData.value;
    }
    function getDragItems() {
        if (!dragData.value) {
            return [];
        }
        return multipleDragData.value ? Object.values(dragData.value) : [dragData.value];
    }
    function setDragData(data, multiple = false) {
        dragData.value = data;
        multipleDragData.value = multiple;
    }
    return {
        isMac,
        multipleDragData,
        clearDragData,
        getDragData,
        getDragItems,
        setDragData,
    };
});
